import React, { useState, useEffect } from 'react';
import { Autocomplete, TextField, CircularProgress } from '@mui/material';
import '../css/AutoComplete.css'
import { makeStyles } from '@mui/styles';
import { request } from '../utils/ApiUtils';
import { showNotification } from '../utils/NotificationUtils';
import Input from './Input';

export default function AutocompletePaginado({ endpoint, label, parameters }) {
    const [options, setOptions] = useState([]); // Dados carregados da API
    const [inputValue, setInputValue] = useState(); // Texto digitado pelo usuário
    const [value, setValue] = useState(null);
    const [loading, setLoading] = useState(false); // Indicador de carregamento
    const [page, setPage] = useState(0); // Página atual para consulta
    const [hasMore, setHasMore] = useState(true); // Controle se há mais páginas para carregar

    useEffect(() => {
        setPage(0); // Reinicia para a página inicial
        setLoading(true);
        try {
            const item = parameters.getValue ? parameters.getValue() : parameters.value;

            if (!item) {
                setValue(null);
                setOptions([]);
                setLoading(false);
                return;
            }

            const value = {
                label: parameters.getLabel(item),
                id: item?.id,
                item: item
            };

            setValue(value);
            if (!options) {
                setOptions([value]);
            }
        } catch (error) {
            console.error('Erro ao buscar opções:', error);
        }
        setLoading(false);
    }, [parameters?.value, parameters?.id]);

    const fetchOptions = async (query, page) => {
        setLoading(true);
        setOptions([]);

        request(`${endpoint}?query=${query}&page=${page}`, {
            type: parameters.GET ? 'GET' : 'POST',
            body: JSON.stringify(parameters?.bodyToSearch || {}),
            callback: (data) => {
                const items = data?.content || [];

            const itemsUpdate = items.map(function (item) {
                    return {
                        label: parameters.getLabel(item),
                        id: item.id,
                        item: item
                    }
                });

                setOptions(itemsUpdate);

                if (data?.last || items.length === 0) {
                    setHasMore(false);
                } else {
                    setHasMore(true);
                }
            },
            callbackError: (responseData, message) => {
                if (responseData?.handledError) {
                    if (responseData?.errors) {
                        Object.entries(responseData?.errors).forEach(([key, value]) => {

                            showNotification(value, 'error', 5000);
                        });
                    } else

                        if (responseData?.error) {
                            showNotification(responseData.error, 'error', 5000);
                        }
                } else {
                    showNotification('Falha ao buscar dados para seleção.', 'error');
                }
            },
            finally: () => {
                setLoading(false);
            }
        })
    };

    // Busca inicial ou quando o usuário digitar
    useEffect(() => {
        if (inputValue || inputValue=='') {
            setPage(0); // Reinicia para a página inicial
            fetchOptions(inputValue, 0); // Busca com o texto digitado
        }
    }, [inputValue]);

    // Função para carregar mais dados ao rolar no menu
    const handleScroll = (event) => {
        const { scrollTop, scrollHeight, clientHeight } = event.target;
        if (scrollTop + clientHeight >= scrollHeight - 10 && !loading && hasMore) {
            fetchOptions(inputValue, page + 1);
            setPage((prevPage) => prevPage + 1); // Incrementa a página
        }
    };

    const onInputChange = (event, newInputValue, reason) => {
        if (reason === 'input') {
            setInputValue(newInputValue); // só faz consulta se foi digitado manualmente
        }
    };

    const autoCompleteEnabled = () => (
        <div className='item-autocomplete' style={{ width: parameters.width || '30%', paddingRight: '10px' }}>
            <div style={{ padding: '2px' }} className="autocomplete">
                <Autocomplete style={{ all: 'unset' }} className="autocomplete"
                    options={options}
                    {...{width: parameters.width, disabled: parameters.disabled}}
                    value={value}
                    getOptionLabel={(option) => option.label}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label={label}
                            // variant="outlined"
                            variant="standard"
                            InputLabelProps={{
                                sx: {
                                    fontSize: '16px',
                                    '&.MuiInputLabel-shrink': {
                                        fontSize: '14px'
                                    }
                                }
                            }}
                            InputProps={{
                                style: (parameters?.error ? {"border-bottom": "2px solid red"} : (parameters?.inputStyle && parameters.inputStyle(value)  )),
                                ...params.InputProps,
                                endAdornment: (
                                    <>
                                        {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                        {params.InputProps.endAdornment}
                                    </>
                                ),
                            }}
                        />
                    )}
                    onChange={(event, value) => {
                        parameters.onChange(value);
                        setValue(value)
                    }}
                    onInputChange={(event, value, reason) => { onInputChange(event, value, reason) }}
                    onOpen={() => fetchOptions( '', 0)} // Busca inicial ao abrir
                    ListboxProps={{
                        onScroll: handleScroll, // Escuta o evento de rolagem
                    }}
                    isOptionEqualToValue={(option, value) => option.id === value?.id}
                />
            </div>
        </div>
    )


    return (
        parameters.disabled ? (<Input
                    type="text"
                    parameters={{label, width: parameters.width, disabled: parameters.disabled, style: parameters.inputStyle ? parameters.inputStyle(value || {}) : {}}}
                    disabled={true}
                    style={parameters.inputStyle ? parameters.inputStyle(value || {}) : {}}
                    value={value?.label}
                />) : autoCompleteEnabled()
    );
}

